export default __webpack_public_path__ + "static/media/159.dc15de3e.png";